export enum FacialBiometryStatus {
  NOT_SUBMITTED = 'FB_NOT_SUBMITTED',
  PENDING = 'FB_PENDING',
  VERIFIED = 'FB_VERIFIED',
  REJECTED = 'FB_REJECTED'
}

/**
 * `errorCode` do catálogo do backend (`facial-biometry-errors.ts`) que a tela
 * trata como aviso, e não como erro. Comparar sempre via `hasApiErrorCode`.
 */
export enum FacialBiometryErrorCode {
  NOTIFICATION_ALREADY_SENT_RECENTLY = 'NOTIFICATION_ALREADY_SENT_RECENTLY',
  DOCTOR_ALREADY_HAS_BIOMETRY = 'DOCTOR_ALREADY_HAS_BIOMETRY'
}

export const BACKEND_TO_FB_STATUS: Record<string, FacialBiometryStatus> = {
  NOT_SUBMITTED: FacialBiometryStatus.NOT_SUBMITTED,
  PENDING: FacialBiometryStatus.PENDING,
  VERIFIED: FacialBiometryStatus.VERIFIED,
  REJECTED: FacialBiometryStatus.REJECTED
}

export const FB_STATUS_TO_BACKEND: Record<FacialBiometryStatus, string> = {
  [FacialBiometryStatus.NOT_SUBMITTED]: 'NOT_SUBMITTED',
  [FacialBiometryStatus.PENDING]: 'PENDING',
  [FacialBiometryStatus.VERIFIED]: 'VERIFIED',
  [FacialBiometryStatus.REJECTED]: 'REJECTED'
}

export const FACIAL_BIOMETRY_STATUS_LABELS: Record<FacialBiometryStatus, string> = {
  [FacialBiometryStatus.NOT_SUBMITTED]: 'Sem biometria',
  [FacialBiometryStatus.PENDING]: 'Em validação',
  [FacialBiometryStatus.VERIFIED]: 'Aprovado',
  [FacialBiometryStatus.REJECTED]: 'Reprovado'
}

export const REJECTION_REASON_OPTIONS = [
  { title: 'Foto borrada', value: 'Foto borrada' },
  { title: 'Rosto coberto', value: 'Rosto coberto' },
  { title: 'Iluminação inadequada', value: 'Iluminação inadequada' },
  { title: 'Suspeita de fraude', value: 'Suspeita de fraude' },
  { title: 'Outros', value: 'OTHER' }
]

export const BIOMETRY_STATUS_FILTER_OPTIONS = Object.entries(FACIAL_BIOMETRY_STATUS_LABELS).map(
  ([value, label]) => ({ id: value, name: label })
)
